import React, { Component } from 'react';
import { groupBy, map } from 'lodash';
import { AsyncTypeahead, Highlighter, Menu, MenuItem } from 'react-bootstrap-typeahead';
import GeoApi from '../../api/destinations';
import './input-search.css';
// import PropTypes from "prop-types";
/* eslint-disable */
class InputSearch extends Component {
  static renderSuperMenu(results, menuProps) {
    let idx = 0;
    const grouped = groupBy(results, (r) => r.country_name);
    const items = Object.keys(grouped)
      .sort()
      .map((region) => [
        !!idx && <Menu.Divider key={`${region}-divider`} />,
        <Menu.Header key={`${region}-header`}>{region}</Menu.Header>,
        map(grouped[region], (state) => {
          const item = (
            <MenuItem key={idx} option={state} position={idx}>
              <Highlighter search={menuProps.text}>{state.name}</Highlighter>
            </MenuItem>
          );

          idx++; /* eslint-disable-line no-plusplus */
          return item;
        }),
      ]);
    return <Menu {...menuProps}>{items}</Menu>;
  }

  constructor(props) {
    super(props);
    this.state = {
      cities: [],
      defaultInputValue: props.defaultInputValue === null ? '' : props.defaultInputValue,
      load: false,
      isLoading: false,
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    if (this.props.defaultInputValue && this.props.defaultInputValue.length === 3) {
      GeoApi.getCityByCode(this.state.defaultInputValue)
        .then((result) => {
          this.setState({
            defaultInputValue: result.nombre,
            load: true,
          });
        })
        .catch((e) => {
          console.error(e);
          this.setState({
            defaultInputValue: '',
            load: true,
          });
        });
    } else {
      this.setState({
        load: true,
      });
    }
  }

  onChange(selected) {
    let item = [
      {
        codigo: '',
        country_code: '',
        country_name: '',
        nombre: '',
        id: 0,
      },
    ];
    if (selected.length !== 0 || selected === undefined) {
      item = selected[0];
    }
    this.props.onChange(item);
  }

  handleSearch(query) {
    this.setState({ isLoading: true }, () => {
      GeoApi.getDestinations(query).then((cities) => {
        this.setState({
          cities,
          isLoading: false,
        });
      });
    });
  }

  render() {
    /* eslint-disable */
    const icon = this.props.inputIcon ? (
      <label className="input-group-addon" htmlFor="cityCode">
        <i className={`fa ${this.props.inputIcon}`} />
      </label>
    ) : (
      ''
    );
    const label = this.props.label ? (
      <label htmlFor={this.props.name}>{this.props.label}</label>
    ) : (
      ''
    );
    /* eslint-enable */
    return (
      <div className="form-group">
        <div className={this.props.inputIcon ? 'input-group' : ''}>
          {label}
          {icon}
          {this.state.load ? (
            <AsyncTypeahead
              id={this.props.id}
              placeholder={this.props.placeHolder}
              onSearch={this.handleSearch}
              options={this.state.cities}
              onChange={this.onChange}
              minLength={3}
              labelKey="nombre"
              filterBy={['nombre', 'codigo']}
              renderMenu={InputSearch.renderSuperMenu}
              searchText="Buscando..."
              promptText="ingresá por lo menos 3 letras..."
              isLoading={this.state.isLoading}
              defaultInputValue={this.state.defaultInputValue}
            />
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }
}

// InputSearch.propTypes = {
//     name: PropTypes.string.isRequired,
//     label: PropTypes.string,
//     defaultInputValue: PropTypes.string,
//
// };

export default InputSearch;
